export const SLIDE_SIZE_DESKTOP = 720;
export const SLIDE_SIZE_TABLET = 480;
export const SLIDE_SIZE_MOBILE = 480;



// WEBPACK FOOTER //
// ./src/scenes/Approach/components/Carousel/constants.js